<div class="container">
  <mat-icon class="check-icon">check</mat-icon>
  <h2 class="title">Would you like to reschedule?</h2>

  <ul class="meeting-info">
    @if (calendar$ | async; as calendar) {
    <li>
      <span
        class="avatar"
        [ngStyle]="{
          'background-image':
            'url(' +
            (calendar?.displayProfileUrl || './assets/images/profile.svg') +
            ')'
        }"
      ></span>
      <span class="display-name">{{ calendar?.displayName }}</span>
    </li>
    }
    <li>
      <div class="meeting-change">
        <span>
          <mat-icon>watch_later</mat-icon>
        </span>
        @if (timeSlot$ | async; as timeSlot) {
        <span data-testid="reschedule-confirmation-meeting-time">
          @if (isTimeSlotChanged$) {
          <div class="meeting-time">
            <span class="changed">Changed:</span>
            <span>
              {{
                timeSlot.start | date : 'h:mm a' : (timezoneOffset$ | async)
              }}
              -
              {{ timeSlot.end | date : 'h:mm a' : (timezoneOffset$ | async) }}
              {{ timeSlot.start | date : 'fullDate' }}
              @if (timeSlot.timezone) {
              {{ timeSlot.timezone?.zone }} ({{ timeSlot.timezone?.region }}) }
            </span>
          </div>
          } @if (!isTimeSlotChanged$) {
          <div>
            <span>
              {{
                timeSlot.start | date : 'h:mm a' : (timezoneOffset$ | async)
              }}
              -
              {{ timeSlot.end | date : 'h:mm a' : (timezoneOffset$ | async) }}
              {{ timeSlot.start | date : 'fullDate' }}
              @if (timeSlot.timezone) {
              {{ timeSlot.timezone?.zone }} ({{ timeSlot.timezone?.region }}) }
            </span>
          </div>
          }
        </span>
        }
      </div>
    </li>
    <li>
      @if ((location$ | async); as location) {
      <div class="meeting-change">
        <span>
          <mat-icon>location_on</mat-icon>
        </span>
        @if (isLocationChanged$) {
        <div class="meeting-time">
          <span class="changed">Changed:</span>
          <span
            data-testid="meeting-location"
            [matTooltip]="location"
            matTooltipShowDelay="500"
            [class.truncated]="location.length > 50"
          >
            {{
              location.length > 50
                ? (location | slice : 0 : 50) + '...'
                : location
            }}
          </span>
        </div>
        } @if (!isLocationChanged$) {
        <div>
          <span
            data-testid="meeting-location"
            [matTooltip]="location"
            matTooltipShowDelay="500"
            [class.truncated]="location.length > 50"
          >
            {{
              location.length > 50
                ? (location | slice : 0 : 50) + '...'
                : location
            }}
          </span>
        </div>
        }
      </div>
      }
    </li>
  </ul>

  <div class="footer">
    <div class="buttons">
      <button
        data-testid="contact-form-cancel-btn"
        mat-button
        color="primary"
        (click)="onCancel()"
      >
        Go Back
      </button>
      <button
        mat-raised-button
        color="primary"
        data-testid="contact-form-submit-btn"
        (click)="onConfirm()"
        [disabled]="!isLocationChanged$ && !isTimeSlotChanged$"
      >
        Reschedule meeting
      </button>
    </div>
  </div>
</div>
